export const FORMINPUT = 'input',
  FORMINPUTNUMBER = 'forminputnumber',
  FORMSELECT = 'formselect',
  FORMDATEPICKER = 'formdatepicker',
  FORMTIMEPICKER = 'formtimepicker',
  FORMRADIO = 'formradio',
  FORMSLECTDEPT = 'formSelecDept',
  FORMSLECTUSER = 'formSelecUser'
export const USERSTATUS = 'userStauts',
  ACCOUNTSTATUS = 'accountStatus',
  APPSCOPE = 'appscope'
